import { Injectable } from '@angular/core';

import { HttpService } from './http.service';
import { ITheme } from '../common/models/theme.interface';
import { Theme } from '../common/enums/theme.enum';
import { IUserLocalStorage } from '../common/models/auth.interface';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  constructor(private http: HttpService) {}

  getCurrentType(): Theme | null {
    const userData = localStorage.getItem('userData');

    if (!userData) {
      return null;
    }
    const user = JSON.parse(userData) as IUserLocalStorage;

    return user.theme.type;
  }

  applyTheme(): void {
    const userData = localStorage.getItem('userData');

    if (!userData) {
      return;
    }
    const user = JSON.parse(userData) as IUserLocalStorage;
    const currentType = user.theme.type;
    this.setThemeColors(user.theme);
    if (currentType === Theme.LIGHT) {
      this.applyLightTheme();
    } else {
      this.applyDarkTheme();
    }
  }

  public setThemeColors(theme: ITheme): void {
    const root = document.documentElement.style;
    root.setProperty('--primary-color', theme.primaryColor);
    root.setProperty('--secondary-color', theme.secondaryColor);
    root.setProperty('--tertiary-color', theme.tertiaryColor);
    root.setProperty('--text-color', theme.textColor);
  }

  public applyDarkTheme(): void {
    console.log('Applying dark theme');
    const root = document.documentElement.style;
    root.setProperty('--input-bg', '#2c2c2c');
    root.setProperty('--shadow', '0 1px 4px rgb(255 255 255 / 35%)');
    root.setProperty('--text-color-secondary', '#bbb');
    root.setProperty('--form-bg', '#181818');
  }

  public applyLightTheme(): void {
    console.log('Applying light theme');
    const root = document.documentElement.style;
    root.setProperty('--input-bg', '#fff');
    root.setProperty('--shadow', 'rgba(0, 0, 0, 0.24) 0px 3px 8px');
    root.setProperty('--text-color-secondary', '#666666');
    root.setProperty('--form-bg', '#e3e3e3');
  }

  resetTheme(): void {
    const root = document.documentElement.style;
    root.removeProperty('--primary-color');
    root.removeProperty('--secondary-color');
    root.removeProperty('--tertiary-color');
    root.removeProperty('--text-color');
    root.removeProperty('--form-bg');
    root.removeProperty('--input-bg');
    root.removeProperty('--shadow');
    root.removeProperty('--text-color-secondary');
  }

  destroy(): void {
    this.resetTheme();
  }
}
